import { runInAction } from 'mobx';
import { createUUID } from '../../../../utils/uuid-utils';
import { temporaryOrderDomainStore } from '../../temporary-store/store';
export const registerOrderAction = (actionDescription) => {
    const uuid = createUUID();
    runInAction(() => {
        temporaryOrderDomainStore.data.inProgressActions.set(uuid, actionDescription);
    });
    return () => {
        runInAction(() => {
            temporaryOrderDomainStore.data.inProgressActions.delete(uuid);
        });
    };
};
